import { render, staticRenderFns } from "./DocumentsTree.vue?vue&type=template&id=98f6fe7c&scoped=true&lang=pug"
import script from "./DocumentsTree.vue?vue&type=script&lang=ts"
export * from "./DocumentsTree.vue?vue&type=script&lang=ts"
import style0 from "./DocumentsTree.vue?vue&type=style&index=0&id=98f6fe7c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f6fe7c",
  null
  
)

export default component.exports